import {__} from "./__";

export const getPlaceholdersList = () => {
    return {
        '{order.id}': __('Id objednávky'),
        '{order.number}': __('Číslo objednávky'),
        '{order.currency}': __('Mena objednávky'),
        '{order.date}': __('Dátum vytvorenia objednávky'),
        '{order.amount}': __('Celková suma objednávky'),
        '{order.discount}': __('Zľava objednávky'),
        '{order.payment_type}': __('Typ úhrady objednávky'),
        '{order.delivery_type}': __('Typ dodania objednávky'),
        '{order.client.id}': __('Id zákazníka'),
        '{order.client.name}': __('Meno zákazníka'),
        '{order.client.ico}': __('IČO zákazníka'),
        '{order.client.dic}': __('DIČ zákazníka'),
        '{order.client.ic_dph}': __('IČ DPH zákazníka'),
        '{order.client.email}': __('Email zákazníka'),
        '{order.client.phone}': __('Tel. číslo zákazníka'),
        '{order.client.address}': __('Adresa zákazníka (fakturácia)'),
        '{order.client.city}': __('Mesto zákazníka (fakturácia)'),
        '{order.client.zip}': __('PSČ zákazníka (fakturácia)'),
        '{order.client.country}': __('Krajina zákazníka (fakturácia)'),
        '{order.client.delivery_address}': __('Adresa zákazníka (dodanie)'),
        '{order.client.delivery_city}': __('Mesto zákazníka (dodanie)'),
        '{order.client.delivery_zip}': __('PSČ zákazníka (dodanie)'),
        '{order.client.delivery_country}': __('Krajina zákazníka (dodanie)'),
        '{order.client.delivery_phone}': __('Tel. číslo zákazníka (dodanie)'),
        '{order.client.delivery_note}': __('Poznámka (dodanie)'),
        '{order.product.name}': __('Názov produktu'),
        '{order.product.quantity}': __('Počet produktu'),
        '{order.product.unit}': __('Jednotka produktu'),
        '{order.product.unit_price}': __('Jednotková cena produktu'),
        '{order.product.total_price}': __('Jednotková cena produktu s DPH'),
        '{order.product.tax}': __('DPH produktu'),
        '{order.product.number}': __('Číslo produktu'),
        '{order.product.ean}': __('EAN produktu'),
        '{order.product.variant}': __('Varianta produktu'),
    };
};
